<template>
	<div class="ph-item m-d-16 p-0">
		<div class="ph-col-12 p-y-12 p-x-20 border-bottom">
			<div class="ph-row m-0">
				<div class="ph-col-4 big m-d-6"></div>
			</div>
			<div class="ph-row m-0">
				<div class="ph-col-4 m-d-4"></div>
			</div>
			<div class="ph-row m-0">
				<div class="ph-col-8 m-d-8"></div>
				<div class="ph-col-8 m-d-8"></div>
			</div>
		</div>
		<div class="ph-col-12 p-y-12 p-x-20 border-bottom">
			<div class="ph-row m-0 d-flex-between-center">
				<div class="ph-col-4 big m-0"></div>
				<div class="ph-col-4 big m-0"></div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "CardSkeleton",
}
</script>